/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/audit-reports-api-client";
import type { GetOlafReprocessJobStatusByOrderIdQueryResponse, GetOlafReprocessJobStatusByOrderIdPathParams, GetOlafReprocessJobStatusByOrderId404 } from "../models/GetOlafReprocessJobStatusByOrderId";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { getOlafReprocessJobStatusByOrderId } from "../axios/getOlafReprocessJobStatusByOrderId";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getOlafReprocessJobStatusByOrderIdQueryKey = (orderId: GetOlafReprocessJobStatusByOrderIdPathParams["orderId"]) => ["audit-reports-api", { url: '/olaf/reprocess/job-status-by-order/:orderId', params: {orderId:orderId} }] as const

export type GetOlafReprocessJobStatusByOrderIdQueryKey = ReturnType<typeof getOlafReprocessJobStatusByOrderIdQueryKey>

export function getOlafReprocessJobStatusByOrderIdQueryOptions(orderId: GetOlafReprocessJobStatusByOrderIdPathParams["orderId"], config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = getOlafReprocessJobStatusByOrderIdQueryKey(orderId)
        return queryOptions<GetOlafReprocessJobStatusByOrderIdQueryResponse, ResponseErrorConfig<GetOlafReprocessJobStatusByOrderId404>, GetOlafReprocessJobStatusByOrderIdQueryResponse, typeof queryKey>({
         enabled: !!(orderId),
         queryKey,
         queryFn: async ({ signal }) => {
            return getOlafReprocessJobStatusByOrderId(orderId, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Finds and returns the most recent reprocess job for the given order ID(s) within the user's client. The provided orders must exactly match the orders in the job.
 * @summary Get OLAF reprocess job status by order ID
 * {@link /olaf/reprocess/job-status-by-order/:orderId}
 */
export function useGetOlafReprocessJobStatusByOrderId<TData = GetOlafReprocessJobStatusByOrderIdQueryResponse, TQueryData = GetOlafReprocessJobStatusByOrderIdQueryResponse, TQueryKey extends QueryKey = GetOlafReprocessJobStatusByOrderIdQueryKey>(orderId: GetOlafReprocessJobStatusByOrderIdPathParams["orderId"], options: 
{
  query?: Partial<QueryObserverOptions<GetOlafReprocessJobStatusByOrderIdQueryResponse, ResponseErrorConfig<GetOlafReprocessJobStatusByOrderId404>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? getOlafReprocessJobStatusByOrderIdQueryKey(orderId)
         

         const query = useQuery({
          ...getOlafReprocessJobStatusByOrderIdQueryOptions(orderId, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<GetOlafReprocessJobStatusByOrderId404>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}